(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("RusCryptoJS", [], factory);
	else if(typeof exports === 'object')
		exports["RusCryptoJS"] = factory();
	else
		root["RusCryptoJS"] = factory();
})(typeof self !== 'undefined' ? self : this, () => {
return 